import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function DeleteAccountModal({ show, onHide }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Delete Account</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          Are you sure you want to delete this account? Type your password.
        </p>

        <Form.Group>
          <Form.Label>Confirm Password *</Form.Label>
          <Form.Control type="password" />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light">Cancel</Button>
        <Button className="orange-btn">Delete Account</Button>
      </Modal.Footer>
    </Modal>
  );
}